import React from 'react';

interface Props
  extends Omit<React.SVGAttributes<SVGElement>, 'width' | 'height'> {
  size?: number | string;
}

const Pens: React.FunctionComponent<Props> = (props) => {
  const { size = 24, ...restProps } = props;
  return (
    <svg
      {...restProps}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_12280_30864)'>
        <path
          d='M13.5119 5.59412H4.8845C4.64629 5.59412 4.45312 5.39812 4.45312 5.15643C4.45312 4.91474 4.64629 4.71875 4.8845 4.71875H13.5119C13.7501 4.71875 13.9433 4.91474 13.9433 5.15643C13.9433 5.39812 13.7501 5.59412 13.5119 5.59412Z'
          fill='url(#paint0_linear_12280_30864)'
          stroke='url(#paint1_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M13.5119 3.84412H4.8845C4.64629 3.84412 4.45312 3.64812 4.45312 3.40643C4.45312 3.16474 4.64629 2.96875 4.8845 2.96875H13.5119C13.7501 2.96875 13.9433 3.16474 13.9433 3.40643C13.9433 3.64812 13.7501 3.84412 13.5119 3.84412Z'
          fill='url(#paint2_linear_12280_30864)'
          stroke='url(#paint3_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M19.7665 7.56525C17.9826 7.56525 16.5312 6.09266 16.5312 4.28262C16.5312 2.47258 17.9826 1 19.7665 1C21.5505 1 23.0018 2.47258 23.0018 4.28262C23.0018 6.09266 21.5505 7.56525 19.7665 7.56525ZM19.7665 1.87537C18.4583 1.87537 17.394 2.95526 17.394 4.28262C17.394 5.60998 18.4583 6.68988 19.7665 6.68988C21.0747 6.68988 22.1391 5.60998 22.1391 4.28262C22.1391 2.95526 21.0747 1.87537 19.7665 1.87537Z'
          fill='url(#paint4_linear_12280_30864)'
          stroke='url(#paint5_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M16.2075 7.56525H4.45091C4.34204 7.56525 4.23717 7.52349 4.15737 7.4483L1.13777 4.60336C0.954183 4.4303 0.953967 4.13512 1.13777 3.96189L4.15737 1.11695C4.23717 1.04175 4.34199 1 4.45091 1H16.2075C16.3728 1 16.5236 1.09585 16.5957 1.24685C16.6678 1.39781 16.6485 1.5773 16.546 1.70896C15.9707 2.44816 15.6665 3.33815 15.6665 4.28262C15.6665 5.2271 15.9707 6.11708 16.546 6.85633C16.6485 6.98799 16.6678 7.16744 16.5957 7.31844C16.5236 7.46939 16.3728 7.56525 16.2075 7.56525ZM4.62031 6.68988H15.4058C14.6104 5.21655 14.5945 3.37815 15.4058 1.87537H4.62031L2.06531 4.28262L4.62031 6.68988Z'
          fill='url(#paint6_linear_12280_30864)'
          stroke='url(#paint7_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M13.5119 13.473H4.8845C4.64629 13.473 4.45312 13.277 4.45312 13.0353C4.45312 12.7937 4.64629 12.5977 4.8845 12.5977H13.5119C13.7501 12.5977 13.9433 12.7937 13.9433 13.0353C13.9433 13.277 13.7501 13.473 13.5119 13.473Z'
          fill='url(#paint8_linear_12280_30864)'
          stroke='url(#paint9_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M13.5119 11.723H4.8845C4.64629 11.723 4.45312 11.527 4.45312 11.2853C4.45312 11.0437 4.64629 10.8477 4.8845 10.8477H13.5119C13.7501 10.8477 13.9433 11.0437 13.9433 11.2853C13.9433 11.527 13.7501 11.723 13.5119 11.723Z'
          fill='url(#paint10_linear_12280_30864)'
          stroke='url(#paint11_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M19.7665 15.4442C17.9826 15.4442 16.5312 13.9716 16.5312 12.1615C16.5312 10.3515 17.9826 8.87891 19.7665 8.87891C21.5505 8.87891 23.0018 10.3515 23.0018 12.1615C23.0018 13.9716 21.5505 15.4442 19.7665 15.4442ZM19.7665 9.75427C18.4583 9.75427 17.394 10.8342 17.394 12.1615C17.394 13.4889 18.4583 14.5688 19.7665 14.5688C21.0747 14.5688 22.1391 13.4889 22.1391 12.1615C22.1391 10.8342 21.0747 9.75427 19.7665 9.75427Z'
          fill='url(#paint12_linear_12280_30864)'
          stroke='url(#paint13_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M16.2075 15.4442H4.45091C4.34204 15.4442 4.23717 15.4024 4.15737 15.3272L1.13777 12.4823C0.954183 12.3092 0.953967 12.014 1.13777 11.8408L4.15737 8.99586C4.23717 8.92066 4.34199 8.87891 4.45091 8.87891H16.2075C16.3728 8.87891 16.5236 8.97476 16.5957 9.12576C16.6678 9.27672 16.6485 9.45621 16.546 9.58787C15.9707 10.3271 15.6665 11.2171 15.6665 12.1616C15.6665 13.106 15.9707 13.996 16.546 14.7353C16.6485 14.8669 16.6678 15.0464 16.5957 15.1974C16.5236 15.3483 16.3728 15.4442 16.2075 15.4442ZM4.62031 14.5688H15.4058C14.6104 13.0955 14.5945 11.2571 15.4058 9.75427H4.62031L2.06531 12.1615L4.62031 14.5688Z'
          fill='url(#paint14_linear_12280_30864)'
          stroke='url(#paint15_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M13.5119 21.3519H4.8845C4.64629 21.3519 4.45312 21.1559 4.45312 20.9142C4.45312 20.6726 4.64629 20.4766 4.8845 20.4766H13.5119C13.7501 20.4766 13.9433 20.6726 13.9433 20.9142C13.9433 21.1559 13.7501 21.3519 13.5119 21.3519Z'
          fill='url(#paint16_linear_12280_30864)'
          stroke='url(#paint17_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M13.5119 19.6019H4.8845C4.64629 19.6019 4.45312 19.4059 4.45312 19.1642C4.45312 18.9226 4.64629 18.7266 4.8845 18.7266H13.5119C13.7501 18.7266 13.9433 18.9226 13.9433 19.1642C13.9433 19.4059 13.7501 19.6019 13.5119 19.6019Z'
          fill='url(#paint18_linear_12280_30864)'
          stroke='url(#paint19_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M19.7665 23.3192C17.9826 23.3192 16.5312 21.8466 16.5312 20.0365C16.5312 18.2265 17.9826 16.7539 19.7665 16.7539C21.5505 16.7539 23.0018 18.2265 23.0018 20.0365C23.0018 21.8466 21.5505 23.3192 19.7665 23.3192ZM19.7665 17.6293C18.4583 17.6293 17.394 18.7092 17.394 20.0365C17.394 21.3639 18.4583 22.4438 19.7665 22.4438C21.0747 22.4438 22.1391 21.3639 22.1391 20.0365C22.1391 18.7092 21.0747 17.6293 19.7665 17.6293Z'
          fill='url(#paint20_linear_12280_30864)'
          stroke='url(#paint21_linear_12280_30864)'
          strokeWidth='0.3'
        />
        <path
          d='M16.2075 23.3192H4.45091C4.34204 23.3192 4.23717 23.2774 4.15737 23.2022L1.13777 20.3573C0.954183 20.1842 0.953967 19.889 1.13777 19.7158L4.15737 16.8709C4.23717 16.7957 4.34199 16.7539 4.45091 16.7539H16.2075C16.3728 16.7539 16.5236 16.8498 16.5957 17.0008C16.6678 17.1517 16.6485 17.3312 16.546 17.4629C15.9707 18.2021 15.6665 19.0921 15.6665 20.0366C15.6665 20.981 15.9707 21.871 16.546 22.6103C16.6485 22.7419 16.6678 22.9214 16.5957 23.0724C16.5236 23.2233 16.3728 23.3192 16.2075 23.3192ZM4.62031 22.4438H15.4058C14.6104 20.9705 14.5945 19.1321 15.4058 17.6293H4.62031L2.06531 20.0365L4.62031 22.4438Z'
          fill='url(#paint22_linear_12280_30864)'
          stroke='url(#paint23_linear_12280_30864)'
          strokeWidth='0.3'
        />
      </g>
      <defs>
        <linearGradient
          id='paint0_linear_12280_30864'
          x1='6.41832'
          y1='4.77844'
          x2='6.46417'
          y2='5.77489'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint1_linear_12280_30864'
          x1='6.41832'
          y1='4.77844'
          x2='6.46417'
          y2='5.77489'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint2_linear_12280_30864'
          x1='6.41832'
          y1='3.02844'
          x2='6.46417'
          y2='4.02489'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint3_linear_12280_30864'
          x1='6.41832'
          y1='3.02844'
          x2='6.46417'
          y2='4.02489'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint4_linear_12280_30864'
          x1='17.8712'
          y1='1.44768'
          x2='20.889'
          y2='7.40912'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint5_linear_12280_30864'
          x1='17.8712'
          y1='1.44768'
          x2='20.889'
          y2='7.40912'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint6_linear_12280_30864'
          x1='4.23845'
          y1='1.44768'
          x2='5.74116'
          y2='8.62212'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint7_linear_12280_30864'
          x1='4.23845'
          y1='1.44768'
          x2='5.74116'
          y2='8.62212'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint8_linear_12280_30864'
          x1='6.41832'
          y1='12.6573'
          x2='6.46417'
          y2='13.6538'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint9_linear_12280_30864'
          x1='6.41832'
          y1='12.6573'
          x2='6.46417'
          y2='13.6538'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint10_linear_12280_30864'
          x1='6.41832'
          y1='10.9073'
          x2='6.46417'
          y2='11.9038'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint11_linear_12280_30864'
          x1='6.41832'
          y1='10.9073'
          x2='6.46417'
          y2='11.9038'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint12_linear_12280_30864'
          x1='17.8712'
          y1='9.32658'
          x2='20.889'
          y2='15.288'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint13_linear_12280_30864'
          x1='17.8712'
          y1='9.32658'
          x2='20.889'
          y2='15.288'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint14_linear_12280_30864'
          x1='4.23845'
          y1='9.32658'
          x2='5.74116'
          y2='16.501'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint15_linear_12280_30864'
          x1='4.23845'
          y1='9.32658'
          x2='5.74116'
          y2='16.501'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint16_linear_12280_30864'
          x1='6.41832'
          y1='20.5363'
          x2='6.46417'
          y2='21.5327'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint17_linear_12280_30864'
          x1='6.41832'
          y1='20.5363'
          x2='6.46417'
          y2='21.5327'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint18_linear_12280_30864'
          x1='6.41832'
          y1='18.7863'
          x2='6.46417'
          y2='19.7827'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint19_linear_12280_30864'
          x1='6.41832'
          y1='18.7863'
          x2='6.46417'
          y2='19.7827'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint20_linear_12280_30864'
          x1='17.8712'
          y1='17.2016'
          x2='20.889'
          y2='23.163'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint21_linear_12280_30864'
          x1='17.8712'
          y1='17.2016'
          x2='20.889'
          y2='23.163'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint22_linear_12280_30864'
          x1='4.23845'
          y1='17.2016'
          x2='5.74116'
          y2='24.376'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <linearGradient
          id='paint23_linear_12280_30864'
          x1='4.23845'
          y1='17.2016'
          x2='5.74116'
          y2='24.376'
          gradientUnits='userSpaceOnUse'>
          <stop stopColor='#2957FF' />
          <stop
            offset='1'
            stopColor='#BB29FF'
          />
        </linearGradient>
        <clipPath id='clip0_12280_30864'>
          <rect
            width='24'
            height='24'
            fill='white'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Pens;
